<template>
  <div>
    <gmap-map ref="map" :center="geocodedLocation" :zoom="zoom" :class="mapClasses">
      <gmap-marker ref="marker" :position="geocodedLocation" :draggable="true" @dragend="handleMarkerDrop" />
    </gmap-map>

    <div v-if="showDebug" class="mt-3 text-sm text-secondary">
      {{ geocodedLocation.lat }}, {{ geocodedLocation.lng }}
    </div>
  </div>
</template>

<script>
import {gmapApi} from 'vue2-google-maps';
import {Map as gmapMap} from 'vue2-google-maps';
import {Marker as gmapMarker} from 'vue2-google-maps';

export default {
  components: {gmapMap, gmapMarker},
  props: {
    initialCoordinates: {
      type: Object,
      default: () => {},
    },
    zoom: {
      type: Number,
      default: 10,
    },
    mapClasses: {
      type: String,
      default: '',
    },
    showDebug: {
      type: Boolean,
      default: false,
    },
    address: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      selectedLatLong: this.initialCoordinates,
      geocodedLocation: this.initialCoordinates,
      geocoder: null,
    };
  },
  computed: {
    google: gmapApi,
  },
  watch: {
    address() {
      if (this.address && this.google && this.geocoder) {
        this.geocoder.geocode(this.address, (results, status) => {
          if (status === 'OK') {
            this.geocodedLocation = {
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng(),
            };
          }
          //emit a mapchanged event with new coords
          this.$emit('map-changed', this.geocodedLocation);
        });
      }
    },
  },
  mounted() {
    this.$refs.map.$mapPromise.then((map) => {
      this.geocoder = new this.google.maps.Geocoder();
      map.setOptions({
        gestureHandling: 'greedy',
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      });
    });
  },

  methods: {
    handleMarkerDrop(event) {
      if (event && event.latLng && event.latLng.lat instanceof Function && event.latLng.lng instanceof Function) {
        this.geocodedLocation = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        };
        console.log(this.geocodedLocation);
        this.$emit('pin-drop', this.geocodedLocation);
      }
    },
  },
};
</script>
